import { OwcBanner } from "@one/react";
import { THEME } from "@digitallab/grid-common-frontend-components";

const CLUSTER_TEXT =
  "Propagation to Equipment Repository is not available for all subcomponents. The respective rows will be disabled. Contact the Equipment Responsible Person if you want to provide update to Equipment Repository.";

const CLUSTER_PENDING_TEXT =
  'Propagation to Equipment Repository is not available for equipment in "Pending" workflow status.';

const NON_CLUSTER_TEXT =
  "Propagation to Equipment Repository is not available. You have selected at least 1 equipment that requires additional review. Contact the Equipment Responsible Person if you want to provide update to Equipment Repository.";

export const PropagationDisabledBanner = ({ cluster = false, pendingOnly = false }) => {
  let text = NON_CLUSTER_TEXT;
  if (cluster && pendingOnly) {
    text = CLUSTER_PENDING_TEXT;
  } else if (cluster) {
    text = CLUSTER_TEXT;
  }
  return (
    <>
      <OwcBanner
        type="info"
        style={{
          top: 0,
          marginBottom: THEME["one-spacer-12"],
          gridColumn: "span 4",
          boxShadow: `${THEME["one-color-background-warning-1"]} 0 0 0 2px`
        }}
      >
        {text}
      </OwcBanner>
    </>
  );
};
